document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".shopify-section--complementary-product")
    .forEach((complementaryProductSection) => {
      complementaryProductSection.addEventListener("click", (event) => {
        const eventPath = event.composedPath
          ? event.composedPath().slice(0, -2)
          : [];

        for (const element of eventPath) {
          const clickAction = element.getAttribute("data-click-action");
          if (!clickAction) continue;

          if (clickAction === "add-product-to-cart") {
            addProductToCart(element, complementaryProductSection);
            break;
          }
        }
      });
    });
});

async function addProductToCart(addToCartButton, section) {
  const variantId = addToCartButton.getAttribute("data-variant-id");

  const addToCartBody = {
    items: [
      {
        id: variantId,
        quantity: 1,
        properties: {
          "_complementary_product": true,
        },
      },
    ],
  };

  try {
    const addToCartJson = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addToCartBody),
    }).then((response) => response.json());

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      }),
    );

    setTimeout(() => {
      document.getElementById("cart-drawer").show();
    }, 1200);
  } catch (error) {
    console.error("Error adding the recommendation product to the cart", error);
  }
}
